import { useQuery } from 'react-query';
import { useRouteMatch } from 'react-router-dom';
import ContentSpinner from './ContentSpinner';

const withContentLoader = (WrappedComponent, { fetchData, name, queryProps }) => {
  function ContentLoader(props) {
    const routeMatch = useRouteMatch();

    const query = useQuery(name, fetchData.bind(this, { routeMatch, ...queryProps }));

    const { isLoading } = query;

    if (isLoading) {
      return <ContentSpinner />;
    }

    return <WrappedComponent {...props} {...query} />;
  }

  return ContentLoader;
};

export default withContentLoader;
